import { SimilarRecentlySoldItemsPriceRange } from './__generated__/PdpSharedRecentSales_item.graphql';

const priceRanges: SimilarRecentlySoldItemsPriceRange[] = [
    'OUT_OF_RANGE_LOW',
    'LOWER_RANGE',
    'NEAR_MEDIAN_LOW',
    'MEDIAN',
    'NEAR_MEDIAN_HIGH',
    'HIGHER_RANGE',
    'OUT_OF_RANGE_HIGH',
];

export function isPriceRangeOrLower(
    priceRange: SimilarRecentlySoldItemsPriceRange | null,
    targetPriceRange: SimilarRecentlySoldItemsPriceRange
): boolean {
    return !!priceRange && priceRanges.indexOf(priceRange) <= priceRanges.indexOf(targetPriceRange);
}

export function isPriceRangeOrHigher(
    priceRange: SimilarRecentlySoldItemsPriceRange | null,
    targetPriceRange: SimilarRecentlySoldItemsPriceRange
): boolean {
    return !!priceRange && priceRanges.indexOf(priceRange) >= priceRanges.indexOf(targetPriceRange);
}
